import { useEffect, useState } from "react";
import moment from "moment";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { generateAxiosInstanceInstitute } from "../../hooks/useAuthorizedRequestForInstitute";
import { useNavigate } from 'react-router-dom';
import { GeneratePdf } from "../../components/GeneratePdf";
import separator_line from "../../assets/separator_line.png";
import { getCurrentTime } from "../../components/CurrentTime";
import { LocalizationProvider, DatePicker, MonthCalendar } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { TextField } from "@mui/material";
import { Loader } from "../../components/ModalsCommonFunctions";
import Swal from "sweetalert2";
import VidyaUpasna from "../../assets/VidyaUpasna.jpg";

const SectionExamReportByDivision = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const inititalFormState = {
        section_id: sectionMasterId,
        grade: '',
        from_date: moment().format('YYYY-MM'),
        to_date: moment().format('YYYY-MM'),
    }
    const [gradeList, setGradeList] = useState(null)
    const [reportData, setReportData] = useState({});
    const [sectionData, setSectionData] = useState(inititalFormState);
    const [divisionWiseExamCount, setDivisionWiseExamCount] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList();
    }, []);

    const getGradeList = (e) => {
        const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setSectionData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
            }
        })
    }

    const handleStartMonth = (newMonth) => {
        setSectionData((prevData) => ({
            ...prevData,
            from_date: newMonth ? newMonth.format('YYYY-MM') : '',
        }));
    };

    const handleEndMonth = (newMonth) => {
        setSectionData((prevData) => ({
            ...prevData,
            to_date: newMonth ? newMonth.format('YYYY-MM') : '',
        }));
    };

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(sectionData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(sectionData)) {
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.'
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [sectionData])

    const showResult = () => {
        if (validateForm()) {
            setLoading(true);
            let apiUrl = `/section-exam-report-by-division?`;
            if (sectionData.section_id) {
                apiUrl += `sectionId=${sectionData.section_id}&`;
            }

            if (sectionData.grade) {
                apiUrl += `instituteGradeId=${sectionData.grade}&`;
            }

            if (sectionData.from_date) {
                apiUrl += `fromDate=${sectionData.from_date}&`;
            }

            if (sectionData.to_date) {
                apiUrl += `toDate=${sectionData.to_date}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    setReportData(response.data);
                    setDivisionWiseExamCount(aggregateExamCounts(response.data.divisions));
                })
                .catch(error => {
                    setReportData({})
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        text: errorMsg
                    })
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(sectionData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const aggregateExamCounts = (data) => {
        const result = {};

        for (const division of data) {
            const divisionName = division.divisionName.trim(); // Trim division name
            for (const exam of division.exams) {
                const month = exam.month.trim(); // Trim month
                const examCount = exam.examCount;

                if (!result[month]) {
                    result[month] = {};
                }
                if (!result[month][divisionName]) {
                    result[month][divisionName] = 0;
                }
                result[month][divisionName] += examCount;
            }
        }

        const divisionTotals = {};
        for (const month in result) {
            for (const divisionName in result[month]) {
                if (!divisionTotals[divisionName]) {
                    divisionTotals[divisionName] = 0;
                }
                divisionTotals[divisionName] += result[month][divisionName];
            }
        }

        // Calculate the total exam count across all divisions for each month
        for (const month in result) {
            result[month].totalExamCount = Object.values(result[month]).reduce((sum, count) => sum + count, 0);
        }

        // Calculate the overall total exam count
        const overallTotalExamCount = Object.values(divisionTotals).reduce((sum, count) => sum + count, 0);
        return {
            monthlyData: result,
            divisionTotals,
            overallTotalExamCount
        };
    }

    const convertDate = (dateStr) => {
        const [year, month] = dateStr.split('-');
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const monthName = monthNames[parseInt(month) - 1];
        return `${monthName} ${year}`;
    };

    const handleInputReset = () => {
        setSectionData(inititalFormState);
        setError(initialErrorState);
        setDivisionWiseExamCount([]);
        setReportData({});
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>

                        <li className="breadcrumb-item active"><span>Report By Division</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-person-chalkboard"></i>Report By Division</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='grade' onChange={handleInputChange} value={sectionData.grade} >
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.grade && <p style={{ color: 'red' }}>{error.grade}</p>}
                                                </div>

                                                <div className="col-md-6 full_wrap">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>From Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(sectionData.from_date)}
                                                            onChange={handleStartMonth} // Use the month picker handler here
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                    {error.from_date && <p style={{ color: 'red' }}>{error.from_date}</p>}
                                                </div>

                                                <div className="col-md-6 full_wrap">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>To Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(sectionData.to_date)}
                                                            onChange={handleEndMonth} // Use the month picker handler here
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                    {error.to_date && <p style={{ color: 'red' }}>{error.to_date}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    <button className="btn btn-primary" type="button" onClick={showResult}>Show</button>
                                                    <button className="btn btn-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                </div>

                                                {sectionData.section_id.length !== 0 && sectionData.grade.length !== 0 && sectionData.from_date.length !== 0 && sectionData.to_date.length !== 0 && Object.keys(reportData).length !== 0 &&
                                                    (<>
                                                        <div className="separator"></div>
                                                        {reportData && Object.keys(reportData).length !== 0 ? (
                                                            <>
                                                                <GeneratePdf id="examReportContent" />
                                                                <div className="d-grid gap-2 mt-2">
                                                                    <div class="report_block" id="examReportContent">
                                                                        <div class="heading">
                                                                            <div class="logo">
                                                                                <img src={reportData.section.instituteMasterDetails.logoPath} alt="" />
                                                                            </div>
                                                                            <h3 class="text_center">{reportData.section.instituteMasterDetails.instituteName}</h3>
                                                                            <div class="logo">
                                                                                <img src={VidyaUpasna} alt="" />
                                                                            </div>
                                                                        </div>
                                                                        <div class="report_code text_center">
                                                                            <img src={separator_line} alt="" className="line" />
                                                                            <span className="txt">Exam Report</span>
                                                                        </div>
                                                                        <div class="report_head">
                                                                            <span>Section: {reportData.section.sectionName}</span>
                                                                            <span>Board: {reportData.section.boardMasterDetails.boardName}</span>
                                                                            <span>Medium: {reportData.section.streamOrMediumMasterDetails.streamName}</span>
                                                                        </div>
                                                                        <div class="exam_report">
                                                                            <span class="table_caption">Name of Report : Class Exam</span>
                                                                            <table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th rowspan="2">Sr no.</th>
                                                                                        <th rowspan="2">Class</th>
                                                                                        <th colspan="2">Date</th>
                                                                                        <th colspan={Object.keys(divisionWiseExamCount?.divisionTotals).length}>Division</th>
                                                                                        <th rowspan="2">Total</th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th>From</th>
                                                                                        <th>To</th>
                                                                                        {Object.keys(divisionWiseExamCount?.divisionTotals)?.map(key => (
                                                                                            <th key={key}>{key}</th>
                                                                                        ))}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>1</td>
                                                                                        <td>{reportData.grade.gradeName}</td>
                                                                                        <td>{reportData.fromDate}</td>
                                                                                        <td>{reportData.toDate}</td>
                                                                                        {Object.keys(divisionWiseExamCount?.divisionTotals)?.map(key => (
                                                                                            <td key={key}>{divisionWiseExamCount?.divisionTotals[key]}</td>
                                                                                        ))}
                                                                                        <td>{divisionWiseExamCount?.overallTotalExamCount}</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div class="analysis_report">
                                                                            <span class="table_caption">Report Analysis : Class Exam (Month Wise)</span>
                                                                            <table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th rowspan="2">Sr No</th>
                                                                                        <th rowspan="2">Class</th>
                                                                                        <th rowspan="2">Month</th>
                                                                                        <th colspan={Object.keys(divisionWiseExamCount?.divisionTotals).length}>Division</th>
                                                                                        <th rowspan="2">Total</th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        {Object.keys(divisionWiseExamCount?.divisionTotals)?.map(key => (
                                                                                            <th key={key}>{key}</th>
                                                                                        ))}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td rowspan={Object.keys(divisionWiseExamCount?.monthlyData).length * 2}>1</td>
                                                                                        <td rowspan={Object.keys(divisionWiseExamCount?.monthlyData).length * 2}>{reportData.grade.gradeName}</td>
                                                                                        <td>{convertDate(Object.keys(divisionWiseExamCount?.monthlyData)[0])}</td>
                                                                                        {Object.values(Object.values(divisionWiseExamCount?.monthlyData)[0]).map((value, index) => (
                                                                                            <td key={index}>{value}</td>
                                                                                        ))}
                                                                                    </tr>
                                                                                    {Object.keys(divisionWiseExamCount?.monthlyData).slice(1).map((key, index) => (
                                                                                        <tr>
                                                                                            <td>{convertDate(key)}</td>
                                                                                            {Object.values(divisionWiseExamCount?.monthlyData[key]).map((value, i) => (
                                                                                                <td key={i}>{value}</td>
                                                                                            ))}
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                                <tfoot>
                                                                                    <tr>
                                                                                        <th colspan="3" class="text_right">Total</th>
                                                                                        {Object.keys(divisionWiseExamCount?.divisionTotals)?.map(key => (
                                                                                            <th key={key}>{divisionWiseExamCount?.divisionTotals[key]}</th>
                                                                                        ))}
                                                                                        <th>{divisionWiseExamCount?.overallTotalExamCount}</th>
                                                                                    </tr>
                                                                                </tfoot>
                                                                            </table>
                                                                        </div>

                                                                        <div class="report_footer">
                                                                            <div class="timestamp">
                                                                                <span>{getCurrentTime()}</span>
                                                                                <span>Time stamp of export</span>
                                                                            </div>
                                                                            <div class="section_incharge">
                                                                                <span>{reportData?.section?.sectionInchargeName}</span>
                                                                                <span>Section Incharge Name</span>
                                                                            </div>
                                                                            <div class="institute_head">
                                                                                <span>{reportData?.section?.instituteMasterDetails?.inchargeName}</span>
                                                                                <span>Institute Head Name</span>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="text-center" style={{ padding: "50px", fontWeight: 'bold' }}>
                                                                No Result Available
                                                            </div>
                                                        )}
                                                    </>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionExamReportByDivision;